module.exports = __webpack_public_path__ + "static/media/Isabella.1546a657.jpg";